import type { FunctionComponent } from 'react';

export const RequestChangeIcon: FunctionComponent = () => (
    // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
    <svg fill="none" height="16" viewBox="0 0 17 16" width="17" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.00016 14C9.36835 14 9.66683 13.7015 9.66683 13.3333C9.66683 12.9651 9.36835 12.6667 9.00016 12.6667C8.63197 12.6667 8.3335 12.9651 8.3335 13.3333C8.3335 13.7015 8.63197 14 9.00016 14Z"
            fill="#6E6E6C"
        />
        <path
            d="M14.3335 7.33333C14.3335 6.96514 14.035 6.66667 13.6668 6.66667C13.2986 6.66667 13.0002 6.96514 13.0002 7.33333C13.0002 7.70152 13.2986 8 13.6668 8C14.035 8 14.3335 7.70152 14.3335 7.33333Z"
            fill="#6E6E6C"
        />
        <path
            d="M13.6198 9.51197C13.9387 9.69607 14.0479 10.1038 13.8638 10.4227C13.6797 10.7415 13.272 10.8508 12.9531 10.6667C12.6343 10.4826 12.525 10.0748 12.7091 9.75599C12.8932 9.43713 13.3009 9.32788 13.6198 9.51197Z"
            fill="#6E6E6C"
        />
        <path
            d="M11.9119 12.8628C12.2308 12.6787 12.34 12.271 12.1559 11.9521C11.9718 11.6333 11.5641 11.524 11.2452 11.7081C10.9264 11.8922 10.8171 12.2999 11.0012 12.6188C11.1853 12.9377 11.593 13.0469 11.9119 12.8628Z"
            fill="#6E6E6C"
        />
        <path
            d="M12.9515 5.33333C12.6326 5.51743 12.2249 5.40818 12.0408 5.08931C11.8567 4.77045 11.9659 4.36273 12.2848 4.17863C12.6037 3.99454 13.0114 4.10379 13.1955 4.42265C13.3796 4.74151 13.2703 5.14924 12.9515 5.33333Z"
            fill="#6E6E6C"
        />
        <path
            d="M6.50016 9.83333V13.5H2.8335M6.3335 13.1251C4.28482 12.325 2.8335 10.332 2.8335 8C2.8335 4.96243 5.29593 2.5 8.3335 2.5C9.10265 2.5 9.83493 2.65788 10.4997 2.94301"
            stroke="#6E6E6C"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);
